import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lf_lang") || "en");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("lf_lang", l);
  };
  const t = useCallback((key) => translations[lang][key] || key, [lang]);
  return (
    <LangCtx.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
